<template>
  <element>
    <nav-breadcrumb :menu="[{label: '意向进件'}, {label: '审核&授信'}]"/>

    <el-row>
      <el-col class="grid-content bg-purple">

        <el-steps :active="1000" class="step-shenpi">
          <el-step :title="'客户送审'"  :description="$moment((customerDetail.t__applicationDate||{})).format('YYYY-MM-DD HH:mm:ss')">
            <i class="step-start" slot="icon"></i>
          </el-step>

          <el-step v-for="(item, idx) in (customerDetail.approvals||[]).filter(item=>item.a__approvingDate)" class="step-spec" :description="$moment(item.a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(item.a__approvingStatus)" :key="idx" >
              <i class="step-mid" slot="icon" v-if="item.a__approvalType!='reStart'"></i>
              <div  v-if="item.a__approvalType!='reStart'" slot="title">{{Status2CN(item.a__nodeName)}} <br />{{item.a__approverName}}</div>
              <i class="step-start" slot="icon" v-if="item.a__approvalType=='reStart'"></i>
              <div  v-if="item.a__approvalType=='reStart'" slot="title">{{Status2CN(item.a__nodeName)}} </div>
          </el-step>

          <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Approved'" >
            <i class="step-over" slot="icon"></i>
          </el-step>
          <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Completed'" >
            <i class="step-over" slot="icon"></i>
          </el-step>
        </el-steps>

        <el-tabs v-model="tabName">
          <template>
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <panel label="基本信息">
                <form-build
                  :form-data="customerDetail"
                  :form-rules="customerRules"
                  :form-columns="customerColumns"
                  class="formTable"
                />
              </panel>
              <panel label="证件图片" class="zhengjianxinxi">
                <photo-browser v-model="customerDetail.pic__customerICFront" type='image' label="本人身份证正面"/>
                <photo-browser v-model="customerDetail.pic__customerICBack" type='image' label="本人身份证反面"/>
                <photo-browser v-model="customerDetail.pic__customerHukou1" type='image' label="本人户口本主页"/>
                <photo-browser v-model="customerDetail.pic__customerHukou2" type='image' label="本人户口本"/>
                <photo-browser v-model="customerDetail.pic__marriageCert" type='image' label="结婚证明"/>

                <photo-browser v-model="customerDetail.pic__spouseICFront" type='image' label="配偶身份证正面"/>
                <photo-browser v-model="customerDetail.pic__spouseICBack" type='image' label="配偶身份证反面"/>
                <photo-browser v-model="customerDetail.pic__divorceCert" type='image' label="离婚证"/>
                <photo-browser v-model="customerDetail.pic__singleCert" type='image' label="单身证明"/>
                  <photo-browser v-model="customerDetail.pic__singleCert" type='image' label="单身证明"/>

              </panel>

              <panel label="银行流水和征信证明等附件" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2"> <file-upload  v-model="customerDetail.att__bankStatement" :editable="false" ></file-upload>借款人银行流水</div>
                <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerDetail.att__creditReport" :editable="false" ></file-upload>征信报告</div>
                  <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerDetail.pic__marriageCertII" :editable="false" ></file-upload>婚档</div>
                  <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerDetail.att__bizFile" :editable="false" ></file-upload>经营佐证</div>
                  <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerDetail.att__miscFile" :editable="false" ></file-upload>其他资料</div>
              </panel>
            </el-tab-pane>
            <el-tab-pane label="抵押房屋" name="House">
                <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in customerDetail.properties" :key="idx" >
                    <div v-for="(itemP, idxP) in item.pr__owners" :key="idxP">
                        <form-build
                            :form-data="itemP"
                            :form-rules="fangRulesP"
                            :form-columns="houseColumnsP"
                            class="formTable"
                        />
                        <br/>
                        <br/>
                    </div>
                      <panel label="房屋信息">
                        <form-build
                          :form-data="item"
                          :form-rules="customerRules"
                          :form-columns="houseColumns"
                          class="formTable"
                        />
                      </panel>
                      <panel label="资产证明" class="zhengjianxinxi">
                        <photo-browser v-model="item.pr__propertyCert" type='img' label="房产证"/>
                        <photo-browser v-model="item.pr__propertyLand" type='img' label="土地证"/>
                          <photo-browser v-model="item.pr__propertyLogbook" type='img' label="产调"/>
                      </panel>
                    <data-table
                        :table-data="{data:item.pr__values, propertyIdx:idx}"
                        :columns="columns"
                        :page.sync="page"
                        :filters.sync="filters"
                        :actions="actions"
                        :isPaginationShow="false"
                        ref="tableForm"
                    />
                    <div class="totalltxt tr of">
                        平均值： {{pjdjArr[idx]|formatMoney}}
                    </div>
                    <form-build
                        :form-data.sync="item"
                        :form-rules="customerRules2"
                        :form-columns="asmColumns2"
                        class="formTable"
                    />
                </panel>
            </el-tab-pane>
            <el-tab-pane label="共借人" name="borrower">
              <panel v-for="(item, idx) in customerDetail.coborrowers" :key="idx">
                <el-checkbox true-label="true" false-label="false" :label="'共借人'+(idx+1)" v-model="item.co__checked" disabled v-if="item.co__checked"></el-checkbox>
                <panel class="zhengjianxinxi"  v-if="item.co__checked">
                  <form-build
                    :form-data.sync="item"
                    :form-rules="coRules"
                    :form-columns="coColumns"
                    class="formTable"
                    v-if="item.co__checked"
                  />
                </panel>
                <panel class="zhengjianxinxi"  v-if="item.co__checked">
                  <photo-browser v-model="item.co__borrowerICFront" type='image' label="本人身份证正面"/>
                  <photo-browser v-model="item.co__borrowerICBack" type='image' label="本人身份证反面"/>
                    <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="item.co__borrowerHukou1" :editable="false" ></file-upload>户口本</div>
                </panel>
              </panel>
            </el-tab-pane>
            <el-tab-pane  label="收款银行账户" name="bank">
              <panel class="zhengjianxinxi">
                <form-build
                  :form-data.sync="customerDetail"
                  :form-rules="bankRules"
                  :form-columns="bankColumns"
                  class="formTable"
                  form-name="formSubmit4" ref="formBuildName4"
                />
              </panel>
              <panel class="zhengjianxinxi">
                <photo-browser v-model="customerDetail.pic__customerBankCardFront" type='image' label="银行卡正面"/>

              </panel>
            </el-tab-pane>
          </template>
        </el-tabs>

        <panel label="评估信息">
         <!-- <data-table
            :table-data="tableData"
            :columns="columns"
            :page.sync="page"
            :filters.sync="filters"
            :actions="actions"
            :isPaginationShow="false"
            ref="tableForm"
          />
          <div class="totalltxt tr of">
            平均值： {{numberAverage|formatMoney}}
          </div>-->
          <form-build
            :form-data.sync="customerDetail"
            :form-rules="customerRules"
            :form-columns="asmColumns"
            class="formTable"
          />
        </panel>
          <panel label="风控材料（包含房价、法务、一账通，产调等相关信息）" class="zhengjianxinxi">
              <div class="zhenjianyyzz zhenjianyyzz2"> <file-upload  v-model="customerDetail.asr__attachment1" :editable="false" ></file-upload></div>
          </panel>
        <panel label="审核流程">
          <data-table
            :table-data="{data: customerDetail.approvals||[]}"
            :columns="approvalTableColumns"
            :is-pagination-show="false"
          />
        </panel>
        <panel label="审核意见">

          <el-col :span="24">
            <el-form :model="customerDetail" inline >
              <el-form-item label="审核意见" ><el-input type="textarea" v-model="customerDetail.a__remarks" style="width:600px"></el-input></el-form-item>
            </el-form>

          </el-col>
        </panel>

      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit('Approved')">审核通过</el-button>
      <el-button type="" @click="onSubmit('Rejected')">否决</el-button>
    </div>
    </element>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import Panel from "../../components/Panel";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "CustomerApplyingApproveKF",
      components: {Panel},
      data(){
          return {
            bankRules: {
            },
            bankColumns:[
              {
                label: '户名',
                field: 'ba__customerName',
                type: 'text',
              },
              {
                label: '账号',
                field: 'ba__customerBankAccountNo',
              },
              {
                label: '开户银行',
                field: 'ba__customerBankName',
                span:24
              },
            ],
            interestType:'',
            coRules:{

            },
            coColumns:[
              {
                label: '与借款人关系',
                field: 'co__relationship',
              },
              {
                label: '姓名',
                field: 'co__borrowerName',
              },
              {
                label: '身份证号码',
                field: 'co__borrowerIC',
              },
              {
                label: '手机号',
                field: 'co__borrowerContactNo',
              },
              {
                label: '住所地址',
                field: 'co__borrowerAddress',
              },
            ],
            tabName: 'CustomerSummary',
            applicationId: this.$route.query['applicationId']||'',
            role1: this.$route.query['role1']||'',
            customerDetail:{
              approvals: []
            },
              fangRulesP: {},
              houseColumnsP:[
                  {
                      label: '姓名',
                      field: 'ow__ownerName',

                  },
                  {
                      label: '身份证号',
                      field: 'ow__ownerIC',

                  },
                  {
                      label: '手机号',
                      field: 'ow__ownerContactNo',
                      span:24
                  },
                  {
                      label: '住所地址',
                      field: 'ow__ownerAddress',
                      span:24
                  },
              ],
            houseColumns:[
                {
                    label: '用途',
                    field: 'pr__propertyUsage',

                },
              {
                label: '位置',
                field: 'pr__propertyLocation',

              },
                {
                    label: '产权证号',
                    field: 'pr__propertyCertNo',

                },
              {
                label: '面积',
                field: 'pr__propertyArea',
                unit:'㎡'

              },
            {
                label: '土地使用权面积',
                field: 'pr__propertyLandArea',
                unit:'㎡'
            },

              {
                label: '土地证',
                field: 'pr__propertyLandNo',
              },
            ],
            customerRules2:{},
            asmColumns2:[
                  {
                      label: '评估单价',
                      field: 'asm__assessedUnitValue',
                      formatter: function (c,v) {
                          return formatMoney(v)
                      },
                      unit:'元/㎡'
                  },
                  {
                      label: '实际评估价',
                      field: 'asm__assessedTotalValue',
                      formatter: function (c,v) {
                          return formatMoney(v)
                      },
                      unit:'元'
                  },
                  {
                      label: '名义评估价',
                      field: 'asm__nominalTotalValue',
                      formatter: function (c,v) {
                          return formatMoney(v)
                      },
                      unit:'元',
                      span:24
                  },
                  {
                      label: '名义评估价说明',
                      field: 'asm__nominalValueRemarks',
                      span:24
                  },
                  {
                      label: '抵押顺位',
                      field: 'asm__pledgeGrade',

                  },
                  {
                      label: '抵押率',
                      field: 'asm__pledgeRate',
                      unit:'%'
                  },
                  {
                      label: '一抵余额',
                      field: 'asm__pledgeExAmount',
                      formatter: function (c,v) {
                          return formatMoney(v)
                      },
                      unit:'元',
                      span:12
                  },
                {
                    label: '一抵债权金额',
                    field: 'asm__pledgeRightsAmount',
                    formatter: function (c,v) {
                        return formatMoney(v)
                    },
                    unit:'元',
                    span:12
                },
                  {
                      label: '产调情况',
                      field: 'asm__pledgeRemarks',

                      span:24

                  },

              ],
            asmColumns:[

                  {
                      label: '核定贷款金额',
                      field: 'asr__approvedAmount',
                      formatter: function (c,v) {
                          return formatMoney(v)
                      },
                      unit:'元',
                      span:24
                  },

                  {
                      label: '其他资产情况',
                      field: 'asr__otherAssets',

                      span:24

                  },
                  {
                      label: '网络核查情况',
                      field: 'asr__internetCheck',

                      span:24

                  },
                  {
                      label: '评估情况',
                      field: 'asr__accessmentRemarks',
                      span:24

                  },
                  {
                      label: '结论',
                      field: 'asr__accessmentResult',
                      span:24

                  },

              ],
            customerRules:{},
            page: 1,
            pageSize: 20,
            actions: [

            ],
            filters: {
              form: {

              },
              columns: [

              ]
            },
            tableData :{
              count: 0,
              data: [
                {
                  pv__ckecked:'true',
                  pv__source:'',
                  pv__quote: '',
                },
              ]
            },
            columns:[
              {
                label: '序号',
                type: 'index'
              },
              {
                label: '查询渠道',
                field: 'pv__source',
              },
              {
                label: '挂牌单价',
                field: 'pv__quote',

                unit:'元/㎡',
              },
            ],
            approvalTableColumns: [
              {
                label: '节点',
                field: 'a__nodeName',
                formatter: (r,c,v)=> {
                  return Status2CN(v)
                }
              },
              {
                label: '操作人',
                field: 'a__approverName'
              },
              {
                label: '操作时间',
                field: 'a__approvingDate',
                formatter: (r,c,v)=>{
                  return moment(v).format('YYYY-MM-DD HH:mm:ss')
                }
              },
              {
                label: '操作结果',
                field: 'a__approvingStatus',
                formatter: (r,c,v)=> {
                  return Status2CN(v)
                }
              },
              {
                label: '操作备注',
                field: 'a__remarks'
              }
            ]
          }
        },
      mounted() {
          this.getApplyingCustomerFang()
      },
      computed:{
          pjdjArr() {
              return this.customerDetail.properties.map(item=> {
                  //  console.log(item)
                  let tempArr = item.pr__values.filter(item=>item.pv__quote)

                  return tempArr.reduce((total, curr) => {
                      total = (Number(curr.pv__quote)||0) + Number(total)
                      return total
                  }, 0)/tempArr.length
              })
          },
        customerColumns(){
          return [
            {
              label: '身份证号码',
              field: 'ba__customerIC',

            },
            {
              label: '客户姓名',
              field: 'ba__customerName',

            },
            {
              label: '性别',
              field: 'ex__customerSex',
              formatter: function (c,v) {
                return Status2CN('Sex_'+v)
              }

            },


            {
              label: '手机号',
              field: 'ba__customerContactNo',
            },
            {
              label: '出生日期',
              field: 'ex__customerDOB',
              formatter: function (r,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
              }
            },

            {
              label: '户口地区',
              field: 'ex__customerHukou',
            },

            {
              label: '籍贯',
              field: 'ex__customerJiguan',
            },
            {
              label: '常住地址',
              field: 'ex__customerAddress',

            },

            {
              label: '婚姻状况',
              field: 'ex__customerMartialStatus',

            },
              {
                  label: '行业类型',
                  field: 'i3__name',
                  formatter: function (r,v) {
                      return (r.i1__name?(r.i1__name):"")+(r.i2__name?("/"+r.i2__name):"")+(r.i3__name?("/"+r.i3__name):"")
                  }
              },
            {
              label: '配偶姓名',
              field: 'ex__spouseName',

            },
            {
              label: '配偶身份证号码',
              field: 'ex__spouseIC',

            },
            {
              label: '配偶手机',
              field: 'ex__spouseContactNo',

            },
              {
                  label: '配偶户口',
                  field: 'ex__spouseHukou',

              },
              {
                  label: '配偶生日',
                  field: 'ex__spouseDOB',
                  formatter: function (r,v) {
                      if(v)
                          return moment(v).format('YYYY-MM-DD')
                  }
              },

              {
                  label: '配偶籍贯',
                  field: 'ex__spouseJiguan',
              },
            {
              label: '申贷金额',
              field: 'ba__amount',
              formatter: function (c,v) {
                return formatMoney(v)
              },
              span:12
            },
            {
              label: '贷款产品',
              field: 'ba__productName',
            },
            {
              label: '贷款利率',
              field: 'interestType',


            },
            {
              label: '还款期数（月）',
              field: 'ba__repaymentCount',
            },
              {
                  label: '业务城市',
                  field: 't__regionName',
                  span:24
              },
            {
              label: '贷款用途',
              field: 'ex__purpose',
              span:24
            },
            {
              label: '客户来源',
              field: 'ba__channel',
            },

            {
              label: '分配渠道商',
              field: 'd__dealerName'
            },
            {
              label: '进件人',
              field: 'jinjian__userName'
            },
            {
              label: '渠道商审核人员',
              field: 'chushen__userName'
            },


          ]
        },

      /*  numberAverage: function () {
            let arr = this.tableData.data.map(item=>item.pv__quote).filter(item=>item)
            return (arr.reduce(
              (total,curr)=> {
                total += Number(curr)||0
                return total
              }, 0
            ) / arr.length)||0
          }*/
      },
      methods: {
        Status2CN,
          getApplyingCustomerFang : function () {
            xhr.getApplyingCustomerFang({
              't.applicationId': this.$route.query['applicationId']
            }, res=>{
              try{
                if(res.data.status == 'success') {
                  this.customerDetail = res.data.data
                 /* this.tableData.data = this.customerDetail.values.filter(item=>item.pv__source)*/
                  let interestType =  this.customerDetail.ba__interestType

                  if(interestType=='Yearly'){
                    interestType =  this.customerDetail.ba__interestRate+"%（年利率）"
                  }
                  if(interestType=='Daily'){
                    interestType =  this.customerDetail.ba__interestRate+"%（日利率）"
                  }
                  if(interestType=='Monthly'){
                    interestType =  this.customerDetail.ba__interestRate+"%（月利率）"
                  }
                  this.customerDetail.interestType = interestType
                    xhr.getIndustry(
                        Object.assign({
                            pageSize:0
                        }, {},{}),
                        res=> {
                            try {
                                res.data.data.forEach(item=>{
                                  if(item.i__industryId==this.customerDetail.ex__industryId){
                                      this.customerDetail.name = item.i__name
                                  }
                                })
                            }catch(e){}
                        })
                }
                  let approvals = []
                  for(var i=0;i<this.customerDetail.approvals.length;i++){
                      approvals.push(this.customerDetail.approvals[i])
                      if(this.customerDetail.approvals[i].a__approvalType=='ZJL'&&this.customerDetail.approvals[i].a__approvingStatus=='Approved'&&i<this.customerDetail.approvals.length-1){
                          approvals.push({
                              'a__nodeName':'reStart',
                              'a__approvingDate':this.customerDetail.approvals[i].a__approvingDate,
                              'a__approvingStatus':''
                          })
                      }
                  }
                  this.customerDetail.approvals = approvals
              }catch(e){}
            })
          },
        onSubmit :function (status) {
        //  this.customerDetail.values = this.tableData.data
          this.customerDetail.a__approvingStatus = status
            this.customerDetail.properties.forEach(item=>{
                item.pr__values.forEach(item1=>{
                    item1.pv__checked = true
                })
          })
            let properties = this.customerDetail.properties
            let next = false
            if(this.role1==this.customerDetail.t__roleId&&status!='Rejected'){

                for(var i=0;i<properties.length;i++){
                    if(properties[i].asm__nominalTotalValue < (Math.floor(((1.3* properties[i].asm__assessedTotalValue) / 10000))* 10000).toFixed(2)){
                        next = true

                    }
                }
            }
            if(next){
                this.$confirm('名义评估价低于实际评估价的1.3倍，确认要审核通过这笔进件吗？').then(()=>{
                    xhr.updateApproveCustomerFangEdit(
                        this.customerDetail,
                        res=> {
                            try{
                                if(res.data.status == 'success') {
                                    this.$router.push({
                                        path: 'List'
                                    })
                                }else{
                                    this.$message.error(res.data.msgs[0].text)
                                }

                            }catch (e) {

                                this.$message.error(error.msgs[0].text)

                            }
                        }
                    )
                }).catch(()=>{
                })
            }else{
                xhr.updateApproveCustomerFangEdit(
                    this.customerDetail,
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.$router.push({
                                    path: 'List'
                                })
                            }else{
                                this.$message.error(res.data.msgs[0].text)
                            }

                        }catch (e) {

                            this.$message.error(error.msgs[0].text)

                        }
                    }
                )
            }

        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerApplyingApprove.vue